import { render, staticRenderFns } from "./token.view.vue?vue&type=template&id=4c6810c0&scoped=true&"
import script from "./token.view.vue?vue&type=script&lang=ts&"
export * from "./token.view.vue?vue&type=script&lang=ts&"
import style0 from "./token.view.vue?vue&type=style&index=0&id=4c6810c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6810c0",
  null
  
)

export default component.exports